<template>
  <div class="news">
    <div v-if="list.length > 0" class="page-help news-wrapper">
      <h1>{{ $t("news.title") }}</h1>
      <div class="txt">{{ $t("news.newsTxt") }}</div>
      <HeroNews :onenews="news" />
      <div class="wrapp-table-news">
        <OneNews
          v-for="(onenews, index) in list"
          :key="index"
          :onenews="onenews"
          class="news-for-table"
        />
      </div>
      <div v-if="list.length > 0" class="pagination-wrapper">
        <paginate
          v-model="page"
          :page-count="pageCount"
          :prev-text="getPaginationImages('Left')"
          :next-text="getPaginationImages('Right')"
          :container-class="'pagination'"
          :page-class="'page'"
          :click-handler="changePage"
        >
        </paginate>
      </div>
    </div>
    <div v-else class="news-wrapper" style="text-align: center;">
      {{ $t("main.noNews") }}
    </div>
  </div>
</template>

<script>
import OneNews from "@/components/news/newOneNews.vue";
import HeroNews from "@/components/news/heroNews.vue";
// import eventBus from '@/shared/eventBus.js'
import { api } from "@/api";

export default {
  name: "News",
  components: {
    OneNews,
    HeroNews
  },
  data() {
    return {
      news: null,
      list: [],
      page: 1,
      pageCount: 0
    };
  },
  methods: {
    getNews() {
      let params = {
        page: this.page
      };
      api
        .getNews(params)
        .then(res => {
          this.setList(res.data.data);
          this.pageCount = res.data.page_count;
        })
        .catch(e => {
          console.log(e);
        });
    },
    setList(data) {
      if (data && data.length > 0) {
        this.news = data[0];
        this.list = data.slice(1) ? data.slice(1) : [];
      }
    },
    getPaginationImages(side) {
      // let path = require(`@/assets/icons/pagination${side}.png`);
      let path = require(`@/assets/newImges/icons/sliderBtn${side}.svg`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
      this.news = null;
      this.list = [];
      this.getNews();
    }
  },
  mounted() {
    this.getNews();
  }
};
</script>

<style lang="scss" scoped>
.news {
  padding-top: 113px;
  padding-bottom: 60px;
  width: 100%;
  background-image: url("../assets/newImges/background linear.svg") !important;
  background-repeat: no-repeat;
  // background-position: right bottom;
  background-position: center -10%; // -20%
  font-family: Outfit;
  text-align: left;

  .news-wrapper {
    /*  display: flex; */
    height: 100%;

    h1 {
      font-weight: 600;
      font-style: SemiBold;
      font-size: 36px;
      line-height: 66px;
      letter-spacing: 0%;
      color: $blue-1000;
      margin: 0;
      margin-bottom: 21px;
    }
    .txt {
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0%;
      color: $blue-400;
      margin: 0;
      margin-bottom: 67px;
    }

    .wrapp-table-news {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .pagination-wrapper {
      max-width: 1024px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
    }
  }
}
.news-for-table {
  margin-bottom: 50px;
}
@media only screen and (max-width: 768px) {
  .news {
    padding-top: 53px;
    padding-bottom: 40px;
    width: 100%;

    .news-wrapper {
      /*  display: flex; */
      height: 100%;

      h1 {
        font-size: 30px;
        line-height: 36px;

        margin-bottom: 10px;
      }
      .txt {
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0%;

        margin-bottom: 37px;
      }

      .wrapp-table-news {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .pagination-wrapper {
        max-width: 1024px;
        margin: 0 auto;
      }
    }
  }
  .news-for-table {
    max-width: 100% !important;
  }
}
</style>
